export class PurposeSupplyModel {
    public suppId: number = null;
    public suppLoad: string;
    public voltageLevel:string;
    public emdAmount:number;
    public domesticFlag : number;

 }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/purposeOfSupply/purpose.supply.model.ts